export default function floatedInput() {

    // looping through already filled inputs to check if there is a value, if that's the case, add the floated class
    $('div.nf-field-element input').each(function () {
        if ($(this).val() !== '' && $(this).attr('type') !== 'radio' && $(this).attr('type') !== 'checkbox') {
            $(this).addClass('floated');
            $(this).parents('.field-wrap').find('label').addClass('floated');
        }
    })

    $('div.nf-field-element input').focusin(function () {
        $(this).addClass('focus');
        if ($(this).val() == '') {
            $(this).addClass('floated');
            $(this).parents('.field-wrap').find('label').addClass('floated');
        }
    });

    $('div.nf-field-element input').focusout(function () {
        $(this).removeClass('focus');
        if ($(this).val() == '') {
            $(this).removeClass('floated');
            $(this).parents('.field-wrap').find('label').removeClass('floated');
        }
    });
}



// WEBPACK FOOTER //
// ./scripts/modules/form.js